import { render, staticRenderFns } from "./MatchingStep.vue?vue&type=template&id=5614203a&"
import script from "./MatchingStep.vue?vue&type=script&lang=js&"
export * from "./MatchingStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports